<template>
  <div class="com-wrap">
    <div class="mwow-button-filled success" @click="showDialog">
      <slot></slot>
    </div>
    <el-dialog
      title="选择课包"
      width="70%"
      :visible.sync="dialogVisible"
      destroy-on-close
    >
      <common-search-form-wrapper :hiddenExpand="true" :reset="handleReset">
        <el-form size="mini" :model="searchInfo" label-width="50px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="课包:" prop="package_id">
                <el-select
                  v-model="searchInfo.package_id"
                  placeholder="请选择课包"
                  clearable
                  filterable
                  :filter-method="handleSearchPackage"
                  @focus="handleSearchPackage('')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in packageList"
                    :key="item.package_id"
                    :label="item.name"
                    :value="item.package_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="科目:" prop="subject_id">
                <el-select
                  v-model="searchInfo.subject_id"
                  placeholder="请选择科目"
                  clearable
                  filterable
                  :filter-method="handleSearchSubject"
                  @focus="handleSearchSubject('')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in subjectList"
                    :key="item.subject_id"
                    :label="item.subject_title"
                    :value="item.subject_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="课程:" prop="course_id">
                <el-select
                  v-model="searchInfo.course_id"
                  placeholder="请选择课程"
                  clearable
                  filterable
                  :filter-method="handleSearchCourse"
                  @focus="handleSearchCourse('')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in courseList"
                    :key="item.course_id"
                    :label="item.title"
                    :value="item.course_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="类型:" prop="course_type">
                <el-radio-group
                  v-model="searchInfo.course_type"
                  @change="handleSearch"
                >
                  <el-radio-button :label="-1">不限</el-radio-button>
                  <el-radio-button :label="1">1vN</el-radio-button>
                  <el-radio-button :label="2">1v1</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </common-search-form-wrapper>
      <div class="table-wrap">
        <el-table
          size="mini"
          v-horizontal-scroll
          :data="tableData"
          stripe
          ref="mainTable"
          class="mwow-table"
        >
          <el-table-column
            prop="course.title"
            label="课程名称"
          ></el-table-column>
          <el-table-column prop="name" label="课包"></el-table-column>
          <el-table-column prop="quantity" label="课时数"></el-table-column>
          <el-table-column prop="price" label="价格"></el-table-column>
          <el-table-column prop="course.course_type" label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.course">
                {{ scope.row.course.course_type === 1 ? "1vN" : "1v1" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="subject.subject_title"
            label="科目"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="mwow-button" @click="handleSelect(scope.row)">
                选择
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :style="{ float: 'right', padding: '20px' }"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getSelectCourseList, getSeleSubjectsList } from "@/api/globalSearch";
import {
  searchCoursePackageSpecApi,
  selectCoursePackageApi,
} from "@/api/course";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
export default {
  components: {
    commonSearchFormWrapper,
  },
  data() {
    return {
      dialogVisible: false,
      searchInfo: {
        package_id: "",
        subject_id: "",
        course_id: "",
        course_type: -1,
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      courseList: [],
      subjectList: [],
      packageList: [],
    };
  },
  created() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  },
  methods: {
    handleSearchPackage(v) {
      selectCoursePackageApi({
        page: 1,
        page_size: 100,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.packageList = res.data.list;
        }
      });
    },
    handleSearchSubject(v) {
      getSeleSubjectsList({
        page: 1,
        page_size: 100,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.subjectList = res.data.list;
        }
      });
    },
    handleSearchCourse(v) {
      getSelectCourseList({
        page: 1,
        page_size: 100,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.courseList = res.data.list;
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    showDialog() {
      this.dialogVisible = true;
    },
    hideDialog() {
      this.dialogVisible = false;
      const table = this.$refs.mainTable;
      table.clearSelection();
    },
    handleReset() {
      this.searchInfo = {
        package_id: "",
        subject_id: "",
        course_id: "",
        course_type: -1,
      };
      this.handleSearch();
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        sales_status: 1,
      };
      if (this.searchInfo.package_id) {
        option.package_id = this.searchInfo.package_id;
      }
      if (this.searchInfo.course_id) {
        option.course_id = this.searchInfo.course_id;
      }
      if (this.searchInfo.subject_id) {
        option.subject_id = this.searchInfo.subject_id;
      }
      if (this.searchInfo.course_type >= 0) {
        option.course_type = this.searchInfo.course_type;
      }
      searchCoursePackageSpecApi(option).then((res) => {
        if (res.error_code === 0 && res.data.list) {
          res.data.list.map((item) => {
            item.course_type = item.course_type === 1 ? "1vN" : "1v1";
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.page = params.page;
        } else {
          this.tableData = [];
          this.total = 0;
          this.page = 1;
        }
      });
    },
    handleSelect(row) {
      this.$emit("on-change", row);
      this.hideDialog();
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.com-wrap {
  display: inline-block;
}
.pagination-wrap {
  overflow: hidden;
}
</style>
